import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";

const firebaseConfig = {
    apiKey: "AIzaSyDkOxMTbn49cKSHml5tCEiDBcbI3kXC5_Q",
    authDomain: "healthylife-d42c9.firebaseapp.com",
    projectId: "healthylife-d42c9",
    storageBucket: "healthylife-d42c9.appspot.com",
    messagingSenderId: "336192261141",
    appId: "1:336192261141:web:828c958ce3c9300090921c"
  };

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase Authentication and get a reference to the service
export const auth = getAuth(app);
export default app;